export default (value) => {
  if (value) {
    return value === 'true';
  }

  return false;
};
